import changeRole from 'api/change_role.js'
import subscription from 'api/subscription.js'

export default {
  changeRole: changeRole,
  subscription: subscription
}
